<template>
  <nav class="flex text-muted" :aria-label="$t('nav.primary')">
    <div class="flex-1 pr-6">
      <h2 class="text-3xl font-light text-white mb-10">
        {{ $t("greeting", { name: firstName }) }}
      </h2>

      <!-- Primary links -->
      <div class="flex flex-col space-y-7">
        <NavigationBarLink
          :text="$t('home')"
          to="/dashboard"
          icon="home"
          iconType="fas"
        />
        <NavigationBarLink
          :text="$t('nav.explore')"
          to="/explore"
          icon="compass"
          iconType="fas"
        />
        <NavigationBarLink
          :text="$t('nav.timeline')"
          to="/timeline"
          icon="clock"
          iconType="fas"
        />
        <NavigationBarLink
          :text="$t('nav.following')"
          to="/following"
          icon="heart"
          iconType="fas"
          :count="followingCount"
        />
      </div>

      <!-- Secondary links -->
      <div class="mt-14">
        <NavigationBarLink
          :text="$t('nav.about')"
          to="/about"
          icon="question-circle"
          iconType="fas"
        />
      </div>
    </div>

    <!-- Divider -->
    <div class="border-l border-primary-400 self-stretch"></div>
  </nav>
</template>

<script>
import NavigationBarLink from "@/components/navigation/NavigationBarLink.vue";

export default {
  name: "NavigationBar",
  components: { NavigationBarLink },

  computed: {
    firstName() {
      return this.$store.getters.authUser?.name?.split(" ")[0] ?? "there";
    },
    followingCount() {
      return Object.keys(this.$store.getters.seriesList).length;
    },
  },
};
</script>
